/**
 * Standard API error codes used across backend and frontend.
 */

export const ERROR_CODES = Object.freeze({
  // Generic
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  METHOD_NOT_ALLOWED: 'METHOD_NOT_ALLOWED',
  RATE_LIMITED: 'RATE_LIMITED',
  CONFLICT: 'CONFLICT',

  // Validation
  INVALID_INPUT: 'INVALID_INPUT',
  INVALID_PHONE: 'INVALID_PHONE',
  INVALID_TIMING_TOKEN: 'INVALID_TIMING_TOKEN',
  SUBMISSION_TOO_FAST: 'SUBMISSION_TOO_FAST',
  HONEYPOT_TRIGGERED: 'HONEYPOT_TRIGGERED',
  DUPLICATE_ORDER: 'DUPLICATE_ORDER',
  MISSING_REQUIRED_FIELD: 'MISSING_REQUIRED_FIELD',
  CONSENT_REQUIRED: 'CONSENT_REQUIRED',

  // Catalog
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  PRODUCT_OUT_OF_STOCK: 'PRODUCT_OUT_OF_STOCK',
  VARIANT_NOT_FOUND: 'VARIANT_NOT_FOUND',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',

  // Orders
  INVALID_STATUS_TRANSITION: 'INVALID_STATUS_TRANSITION',
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',

  // Infrastructure
  DATABASE_ERROR: 'DATABASE_ERROR',
  STORAGE_ERROR: 'STORAGE_ERROR',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
});

export const USER_FRIENDLY_ERROR_MESSAGES = Object.freeze({
  [ERROR_CODES.INTERNAL_SERVER_ERROR]: {
    fr: 'Une erreur interne est survenue. Veuillez réessayer plus tard.',
    ar: 'حدث خطأ داخلي. يرجى المحاولة مرة أخرى لاحقاً.',
  },
  [ERROR_CODES.NOT_FOUND]: {
    fr: 'Ressource introuvable.',
    ar: 'المورد غير موجود.',
  },
  [ERROR_CODES.PRODUCT_NOT_FOUND]: {
    fr: 'Le produit demandé est introuvable.',
    ar: 'المنتج المطلوب غير موجود.',
  },
  [ERROR_CODES.INVALID_PHONE]: {
    fr: 'Veuillez saisir un numéro de téléphone mobile marocain valide (06, 07 ou +212).',
    ar: 'يرجى إدخال رقم هاتف محمول مغربي صالح (06 أو 07 أو 212+).',
  },
  [ERROR_CODES.RATE_LIMITED]: {
    fr: 'Trop de tentatives effectuées. Veuillez patienter quelques minutes.',
    ar: 'محاولات كثيرة جداً. يرجى الانتظار بضع دقائق قبل المحاولة مجدداً.',
  },
  [ERROR_CODES.DUPLICATE_ORDER]: {
    fr: 'Une commande identique a déjà été enregistrée récemment.',
    ar: 'تم تسجيل طلب مماثل مؤخراً.',
  },
  [ERROR_CODES.SUBMISSION_TOO_FAST]: {
    fr: 'Le formulaire a été envoyé trop rapidement. Veuillez recharger la page.',
    ar: 'تم إرسال النموذج بسرعة كبيرة. يرجى إعادة تحميل الصفحة.',
  },
  [ERROR_CODES.CONSENT_REQUIRED]: {
    fr: 'Vous devez accepter les conditions pour continuer.',
    ar: 'يجب الموافقة على الشروط للمتابعة.',
  },
  [ERROR_CODES.INSUFFICIENT_STOCK]: {
    fr: 'La quantité demandée n’est plus disponible en stock.',
    ar: 'الكمية المطلوبة غير متوفرة في المخزون حالياً.',
  },
});
